import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'shifts/'

const initialState = {
    shifts: [],
    shiftsData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const getShifts = createAsyncThunk('shifts/gs', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'getShifts')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getShiftsData = createAsyncThunk('shifts/gsd', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'getShiftsData')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getSingleShift = createAsyncThunk('shifts/gss', async (shiftID, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'getSingleShift', shiftID)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const updateShift = createAsyncThunk('shifts/us', async (shiftData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'updateShift', shiftData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const addShift = createAsyncThunk('shifts/as', async (shiftData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'addShift', shiftData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const shiftsSlice = createSlice({
    name: 'emp',
    initialState,
    reducers: {
        reset: (state) => {
            state.shifts = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getShifts.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getShifts.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.shifts = action.payload
            })
            .addCase(getShifts.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.shifts = []
            })
            .addCase(getShiftsData.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getShiftsData.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.shiftsData = action.payload
            })
            .addCase(getShiftsData.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.shiftsData = []
            })
    }
})

export const { reset } = shiftsSlice.actions

export default shiftsSlice.reducer